import { useLocation } from "react-router-dom";
import React, { useState } from "react";
import { useAuth } from "../context/AuthContext";
import AccountDeletion, { RetentionNotice } from "../components/AccountDeletion";
import api from "../lib/api";

export default function DeleteAccount() {
  const { user, login, logout } = useAuth();
  const initialDeletion = useLocation().state?.deletion;
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(initialDeletion ? (initialDeletion.cleanup_pending ? "Compte fermé. Des effacements externes restent à traiter par le support." : "Compte supprimé.") : "");
  const [done, setDone] = useState(!!initialDeletion);
  const [receipt, setReceipt] = useState(initialDeletion?.receipt || "");
  const [busy, setBusy] = useState(false);
  const [support, setSupport] = useState("");
  const [recoveryCode, setRecoveryCode] = useState(null);
  return <main className="max-w-xl mx-auto p-6 space-y-5">
    <h1 className="text-2xl font-bold">HitMax — suppression du compte</h1>
    <p>Cette page permet de demander la suppression du compte et des données associées depuis un navigateur, sans installer l’application.</p>
    {done ? <div><p role="status">{message}</p>{receipt && <>
      <p>Conserve ce reçu confidentiel pour consulter l’état de la suppression :</p><code className="break-all select-all">{receipt}</code>
    </>}</div> : user ? <AccountDeletion onDone={async (result) => {
      setMessage(result.cleanup_pending ? "La suppression est enregistrée. L’accès est fermé ; des données ou autorisations externes restent à effacer. Les anciennes photos nécessitent un suivi auprès du fournisseur." : "Ton compte et les données personnelles associées ont été supprimés.");
      setReceipt(result.receipt || ""); setDone(true); await logout();
    }} /> : <>
      <p>Connecte-toi pour confirmer la suppression de ton compte.</p>
      <form className="space-y-3" onSubmit={async (e) => {
        e.preventDefault(); setBusy(true); setMessage("");
        try { await login(email, password); setPassword(""); }
        catch (err) { setMessage(err?.response?.data?.detail || "Connexion impossible"); }
        finally { setBusy(false); }
      }}>
        <label className="block">E-mail<input required type="email" autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className="block bg-black border rounded p-2 w-full" /></label>
        <label className="block">Mot de passe<input required type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className="block bg-black border rounded p-2 w-full" /></label>
        <button disabled={busy} className="underline">Se connecter</button>
      </form>
      <a className="block underline" href="/login" onClick={() => sessionStorage.setItem("hitmax_delete_return", "1")}>Autre méthode de connexion ou mot de passe oublié</a>
      <RetentionNotice />
      {message && <p role="alert">{message}</p>}
    </>}
    <section className="border rounded p-4 space-y-3"><h2 className="font-bold">Suivre une suppression</h2>
      <label className="block">Reçu confidentiel<input autoComplete="off" value={receipt} onChange={(e) => setReceipt(e.target.value)} className="block bg-black border rounded p-2 w-full" /></label>
      <button disabled={busy || receipt.length < 32} className="underline" onClick={async () => {
        setBusy(true);
        try { const { data } = await api.post("/account/deletion-status", { receipt }); setMessage(data.status === "completed" ? "Suppression terminée. Seules les références techniques d’achat décrites ci-dessus sont conservées temporairement." : "Suppression en cours. Le support suit les effacements externes qui restent nécessaires."); }
        catch { setMessage("Suivi introuvable ou indisponible"); }
        finally { setBusy(false); }
      }}>Vérifier la suppression</button>
      {!done && message && <p role="status">{message}</p>}
    </section>
    <section className="border rounded p-4 space-y-3"><h2 className="font-bold">Demande de récupération d’abonnement</h2>
      <p>Si ton ancien compte est supprimé et que tu n’as pas de code, connecte-toi à ton nouveau compte pour enregistrer une demande au support. Aucune attribution automatique ne sera faite sur la seule base d’une adresse e-mail.</p>
      {user && <button disabled={busy} className="underline" onClick={async () => {
        setBusy(true);
        try { const { data } = await api.post("/account/recovery-request"); setSupport(`Demande enregistrée : ${data.reference}. Le support devra vérifier le propriétaire avant toute récupération.`); }
        catch (err) { setSupport(err?.response?.data?.detail || "Demande indisponible"); }
        finally { setBusy(false); }
      }}>Enregistrer une demande de récupération</button>}
      {user && <button disabled={busy} className="block underline" onClick={async () => {
        setBusy(true);
        try { const { data } = await api.get("/account/recovery-request"); setSupport(`État de la demande : ${data.status}`); setRecoveryCode(data.code || null); }
        catch { setSupport("Suivi indisponible"); }
        finally { setBusy(false); }
      }}>Consulter ma demande</button>}
      {recoveryCode && <p>Code personnel à utiliser dans l’application : <code className="break-all select-all">{recoveryCode}</code></p>}
      {support && <p role="status">{support}</p>}
    </section>
  </main>;
}
